import React from "react";
import PropTypes from "prop-types";

import {
  PROJECT_FRAME,
  PROJECT_USERS,
  PROJECT_TEAMS,
  PROJECT_ACTIVITY,
  PROJECT_LEADERBOARD,
  PROJECT_REWARDS,
  PROJECT_BOOKMARKS,
  TOPIC_CATEGORY,
  TOPIC,
  CHALLENGE,
  /* Custom: Achievements button - Profile page */
  PROJECT_PROFILE,
  LOGIN_TOUR
} from "App/Routes";
import Link from "components/shared/Link/Link";

import localize from "lang/localize";

const propTypes = {
  projectId: PropTypes.number.isRequired,
  showTeams: PropTypes.bool,
  showIcons: PropTypes.bool,
  buttons: PropTypes.array,
  language: PropTypes.string,
  /* Custom: handler for opening tour modal */
  handleOpenTourModal: PropTypes.func
};

const defaultProps = {
  showTeams: false,
  showIcons: false
};

/* Custom: addition of icons */
const SidebarLinks = props => (
  <div className="sidebar-links">
    {/* Custom: How to Play button */}
    <div
      className="sidebar-link"
      key={localize("topbar_menu_tour_item", props.language)}
    >
      <Link
        to={LOGIN_TOUR.format(props.projectId)}
        onClick={e => {
          props.handleOpenTourModal(e);
        }}
      >
        <i className="fas fa-info-circle rightmargin-10" />
        {localize("topbar_menu_tour_item", props.language)}
      </Link>
    </div>
    {/* Custom: Achievements button */}
    <div
      className="sidebar-link"
      key={localize("nav_bar_title_items_text", props.language)}
    >
      <Link to={PROJECT_PROFILE.format(props.projectId)}>
        <i className="fas fa-certificate rightmargin-10" />
        {localize("nav_bar_title_items_text", props.language)}
      </Link>
    </div>
    {Array.isArray(props.buttons) && props.buttons.length > 0
      ? props.buttons.map(button => {
          switch (button.buttonType) {
            case "bookmarks":
              return (
                <div className="sidebar-link" key={button.id}>
                  <Link to={PROJECT_BOOKMARKS.format(props.projectId)}>
                    <i className="fas fa-bookmark rightmargin-10" />
                    {button.buttonText}
                  </Link>
                </div>
              );
            case "rewards":
              return (
                <div className="sidebar-link" key={button.id}>
                  <Link to={PROJECT_REWARDS.format(props.projectId)}>
                    <i className="fas fa-gift rightmargin-10" />
                    {button.buttonText}
                  </Link>
                </div>
              );
            case "leaderboard":
              return (
                <div className="sidebar-link" key={button.id}>
                  <Link to={PROJECT_LEADERBOARD.format(props.projectId)}>
                    <i className="fas fa-trophy rightmargin-10" />
                    {button.buttonText}
                  </Link>
                </div>
              );
            case "activity":
              return (
                <div className="sidebar-link" key={button.id}>
                  <Link to={PROJECT_ACTIVITY.format(props.projectId)}>
                    <i className="fas fa-list-alt rightmargin-10" />
                    {button.buttonText}
                  </Link>
                </div>
              );
            case "web-url":
              return (
                <div className="sidebar-link" key={button.id}>
                  <a
                    href={button.objectReference}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link"
                  >
                    <i className="fas fa-external-link-alt rightmargin-10" />
                    {button.buttonText}
                  </a>
                </div>
              );
            case "web-url-session":
              const ENCODED_LINK = encodeURIComponent(button.objectReference);
              return (
                <div className="sidebar-link" key={button.id}>
                  <Link
                    to={PROJECT_FRAME.format(props.projectId, ENCODED_LINK)}
                  >
                    {button.buttonText}
                  </Link>
                </div>
              );
            case "challenge-profile":
              return (
                <div className="sidebar-link" key={button.id}>
                  <Link to={CHALLENGE.format(button.objectReference)}>
                    <i className="gamicons icon-challenge-placeholder rightmargin-10" />
                    {button.buttonText}
                  </Link>
                </div>
              );
            case "topic":
              return (
                <div className="sidebar-link" key={button.id}>
                  <Link to={TOPIC.format(button.objectReference)}>
                    <i className="gamicons icon-topics rightmargin-10" />
                    {button.buttonText}
                  </Link>
                </div>
              );
            case "topic-category":
              return (
                <div className="sidebar-link" key={button.id}>
                  <Link
                    to={TOPIC_CATEGORY.format(
                      props.projectId,
                      button.objectReference
                    )}
                  >
                    <i className="fas fa-layer-group rightmargin-10" />
                    {button.buttonText}
                  </Link>
                </div>
              );
            case "teams":
              return (
                <div className="sidebar-link" key={button.id}>
                  <Link to={PROJECT_TEAMS.format(props.projectId)}>
                    <i className="fas fa-users rightmargin-10" />
                    {button.buttonText}
                  </Link>
                </div>
              );
            case "players":
              return (
                <div className="sidebar-link" key={button.id}>
                  <Link to={PROJECT_USERS.format(props.projectId)}>
                    <i className="fas fa-user rightmargin-10" />
                    {button.buttonText}
                  </Link>
                </div>
              );
            default:
              return null;
          }
        })
      : null}
  </div>
);

SidebarLinks.propTypes = propTypes;
SidebarLinks.defaultProps = defaultProps;

export default SidebarLinks;
